module.exports = __webpack_public_path__ + "static/express-544479a2e99436d307566b3c95e59675.jpg";